<template>
  <section class="info">
    <app-card style="flex-direction: row-reverse;">
      <template v-slot:image>
        <div class="image">
          <img src="../img/boiler-repair.webp" alt="человек ремонтирует котёл">
        </div>
      </template>
      <p><strong>"ОБЛГАЗСЕРВИС-СЕВЕР"</strong> уже более 20 лет работает на рынке отопительного оборудования. Основная сфера нашей профессиональной деятельности - монтаж, пусконаладка и техническое обслуживание котельного оборудования.</p>
    </app-card>
    <app-card>
      <template v-slot:image>
        <div class="image">
          <img src="../img/boiler-second.webp" alt="монтаж котельного оборудования">
        </div>
      </template>
      <p>Наша компания является официальным сервисным центром VIESSMANN, VAILLANT, PROTHERM, SIME.<strong>"ОБЛГАЗСЕРВИС-СЕВЕР"</strong> зарегистрирован в жилищной инспекции #57; заключён договор об аварийно-диспетчерском обслуживании со всеми трестами Мособлгаза.</p>
    </app-card>
    <app-card style="flex-direction: row-reverse;">
      <template v-slot:image>
        <div class="image">
          <img src="../img/boiler-third.webp" alt="кошка греется на батарее">
        </div>
      </template>
      <p>Став нашим клиентом, Вам не придётся
        беспокоиться о тепле в своём доме и самостоятельно разбираться с последствиями
        некачественного монтажа. Вы выбираете нас, а мы экономим Ваше время и нервы.</p>
    </app-card>
  </section>
</template>

<script>
  import AppCard from "@/components/AppCard";

  export default {
    components: {
      AppCard
    }
  }
</script>

<style scoped>
 .info {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   max-width: 1800px;
   margin-left: auto;
   margin-right: auto;
 }

 p {
   display: table-cell;
   vertical-align: middle;
   text-align: center;
   font-size: calc(1vw + 20px);
   padding: 20px;
   font-weight: 450;
 }

 img {
   width: 100%;
   height: 100%;
 }

 .image {
   display: flex;
   justify-content: center;
 }

</style>